import { clsx } from 'external/clsx'
import {FC, PropsWithChildren} from 'external/react'

type PackageFieldProps = {
    label: string    
    value: any
    valueClasses?: any
}

const PackageField : FC<PropsWithChildren<PackageFieldProps>> = props  => {
	const {label, value, valueClasses = {}, children} = props
	return (<div className='form-group row' style={{marginBottom: '1rem'}}>
		<span className='col-sm-3 col-form-label-sm pr-0 ' style={{fontSize: '13px'}}>{label}</span>
		<div className='col-sm-9 flex d-flex'>
			<input type='text' className={clsx('form-control', 'form-control-sm', 'd-inline-flex', {...valueClasses})} value={value} disabled />
			{children}
		</div>
	</div>)
}

export {PackageField as default}